import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import DataTable from 'react-data-table-component';
import Select from 'react-select';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { API_BASE_URL } from '../../../config';

const Qualification = (props) => {

  const { fixNavbar } = props;

  /* ================= STATES ================= */
  const [tableData, setTableData] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [formData, setFormData] = useState({
    company_id: '',
    name: '',
  });
  const [editData, setEditData] = useState({
    education_level_id: '',
    name: '',
  });

  /* ================= FETCH DATA ================= */
  useEffect(() => {
    fetchQualifications();
    fetchCompanies();
  }, []);

  const fetchQualifications = () => {
    axios.get(API_BASE_URL + '/qualification_list', {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` }
    })
    .then(res => {
      setTableData(res.data.data.Document || []);
    })
    .catch(() => toast.error('Failed to load qualification list'));
  };

  const fetchCompanies = () => {
    axios.get(API_BASE_URL + '/all_companys', {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` }
    })
    .then(res => {
      setCompanyList(res.data.data.all_employee || []);
    });
  };

  /* ================= ADD ================= */
  const handleSubmit = (e) => {
    e.preventDefault();

    axios.post(API_BASE_URL + '/add_qualification', formData, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` }
    })
    .then(res => {
      toast.success(res.data.message);
      setTimeout(() => window.location.reload(), 1500);
    })
    .catch(err => toast.error(err.response?.data?.message));
  };

  /* ================= UPDATE ================= */
  const handleEditSubmit = (e) => {
    e.preventDefault();

    axios.post(API_BASE_URL + '/updatequalification', editData, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` }
    })
    .then(res => {
      toast.success(res.data.message);
      setTimeout(() => window.location.reload(), 1500);
    });
  };

  /* ================= SEARCH ================= */
  const filteredData = tableData.filter(item =>
    item.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  /* ================= DATATABLE STYLES ================= */
  const customStyles = {
    headCells: {
      style: {
        fontWeight: '600',
        fontSize: '13px',
        backgroundColor: '#f8f9fa',
      },
    },
    cells: {
      style: {
        fontSize: '13px',
        paddingTop: '8px',
        paddingBottom: '8px',
      },
    },
    rows: {
      style: {
        minHeight: '42px',
      },
    },
  };

  /* ================= COLUMNS ================= */
  const columns = [
   
    {
      name: 'Company',
      selector: row => row.company_id,
    },
    {
      name: 'Education Level',
      selector: row => row.name,
      sortable: true,
    },
    {
      name: 'Action',
      width: '100px',
      cell: row => (
        <button
          className="btn btn-icon btn-sm"
          data-toggle="modal"
          data-target="#editModal"
          onClick={() => setEditData(row)}
        >
          <i className="fa fa-edit" />
        </button>
      ),
    },
  ];

  return (
    <>
      <ToastContainer />

      <div className={`section-body ${fixNavbar ? "marginTop" : ""}`}>
        <div className="container-fluid">

          {/* ================= ADD QUALIFICATION ================= */}
          <div className="card mb-4">
            <div className="card-body">
              <h3 className="card-title" style={{ color: '#e96827' }}>
                Add Qualification
              </h3>

              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-4">
                    <label>Company </label>
                    <Select classNames={{
    control: () => "required-select required-tooltip"
  }}
                      options={companyList}
                      placeholder="Company Name"
                      onChange={sp =>
                        setFormData({ ...formData, company_id: sp.company_id })
                      }
                    />
                  </div>

                  <div className="col-md-4">
                    <label>Education Level </label>
                    <input
                      type="text"
                      className="form-control required-input"
                   placeholder='Education'
                      value={formData.name}
                      onChange={e =>
                        setFormData({
                          ...formData,
                          name: e.target.value.replace(/[^A-Za-z ]/g, ''),
                        })
                      }
                    />
                  </div>
                </div>

                <button className="btn btn-danger mt-3">Save</button>
              </form>
            </div>
          </div>

          {/* ================= QUALIFICATION LIST ================= */}
          <div className="card">
            <div className="card-header d-flex align-items-center">
              <h3 className="card-title mb-0" style={{ color: '#e96827' }}>
                Qualification List
              </h3>

              <div className="ml-auto">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Search..."
                  style={{ width: '220px' }}
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                />
              </div>
            </div>

            <div className="card-body p-0">
              <DataTable
                columns={columns}
                data={filteredData}
                pagination
                dense
                striped
                highlightOnHover
                responsive
                customStyles={customStyles}
              />
            </div>
          </div>

        </div>
      </div>

      {/* ================= EDIT MODAL ================= */}
      <div className="modal fade" id="editModal">
        <form onSubmit={handleEditSubmit}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Edit Qualification</h5>
                <button className="close" data-dismiss="modal">×</button>
              </div>

              <div className="modal-body">
                <label>Education Level</label>
                <input
                  type="text"
                  className="form-control required-input"
                  value={editData.name || ''}
                  onChange={e =>
                    setEditData({ ...editData, name: e.target.value })
                  }
                  required
                />
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" data-dismiss="modal">
                  Close
                </button>
                <button className="btn btn-danger">
                  Save
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  fixNavbar: state.settings.isFixNavbar,
});

export default connect(mapStateToProps)(Qualification);
